export enum MarketTemplate {
    PointBox = "PointBox",
    TwoBox = "TwoBox",
    ThreeBox = "ThreeBox"
}